import { render, staticRenderFns } from "./add_plat.vue?vue&type=template&id=c4d66828&scoped=true&"
import script from "./add_plat.vue?vue&type=script&lang=js&"
export * from "./add_plat.vue?vue&type=script&lang=js&"
import style0 from "./add_plat.vue?vue&type=style&index=0&id=c4d66828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d66828",
  null
  
)

export default component.exports